import { Box, Paper, Typography } from '@mui/material'
import GameTypeIcon from 'Components/_common/GameTypeIcon'
import { useIsAdmin } from 'Components/Auth'
import { sum } from 'lodash-es'
import { useCategoryName, usePlayersCountName } from 'Queries/Dictionaries'
import { When } from 'react-if'
import { navigateToContestPage, navigateToTournamentPage } from 'Scenes/navigators'
import Chip from 'Theme/Chip'
import FAIcon from 'Theme/FAIcon'
import { FA_ICONS } from 'Theme/font-awesome-icon-constants'
import { getDayMonth, getDurationInMonths } from 'utils/date-utils'

const RoadmapEvent = ({ event, clickableContestId, clickableTournamentId, relations }) => {
  const isAdmin = useIsAdmin()
  const contest = relations?.contests?.[event.contest_id]
  const tournament = relations?.tournaments?.[event.tournament_id]
  const categoryName = useCategoryName(contest?.category_id || tournament?.category_id)
  const playersCountName = usePlayersCountName(
    contest?.players_count_id || tournament?.players_counts?.[0]?.players_count_id,
  )
  const prize = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(contest?.prize_value || sum(tournament?.prizes))

  const getEventStatus = () => {
    if (event.is_started) {
      return 'In progress'
    } else {
      return 'Upcoming'
    }
  }
  const getEventSchedule = () => {
    if (contest) {
      if (!contest.time_add_maps_end) return `${getDayMonth(contest.time_begin)} - TBA`
      return `${getDayMonth(contest.time_begin)} - ${getDayMonth(contest.time_add_maps_end)} (${getDurationInMonths(
        contest.time_begin,
        contest.time_add_maps_end,
      )})`
    } else if (tournament) {
      const monthsDuration = getDurationInMonths(tournament.time_signup_start, tournament.time_tournament_start)
      return `${getDayMonth(tournament.time_signup_start)} - ${getDayMonth(
        tournament.time_tournament_start,
      )} (${monthsDuration})`
    }
  }

  if (!contest && !tournament) return null

  const isClickable =
    clickableContestId === event.contest_id ||
    clickableTournamentId === event.tournament_id ||
    event.is_started ||
    isAdmin
  return (
    <Paper
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        minWidth: '250px',
        overflow: 'hidden',
        cursor: isClickable ? 'pointer' : 'default',
        padding: 2,
        gap: 2,
      }}
      onClick={() => {
        if (!isClickable) return
        if (contest) {
          navigateToContestPage(contest.id)
        } else if (tournament) {
          navigateToTournamentPage(tournament.id)
        }
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
          <Typography
            variant="subtitle2"
            color="text.tertiary"
          >
            {getEventStatus()}
          </Typography>
          <Typography
            variant="caption"
            color="secondary.main"
            sx={{ textTransform: 'uppercase' }}
          >
            {getEventSchedule()}
          </Typography>
        </Box>
        <Chip
          label={
            <Typography
              variant="overline"
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '7px 14px',
                textTransform: 'uppercase',
              }}
            >
              <FAIcon
                iconClassName={FA_ICONS.TROPHY}
                iconFontSize={16}
              />
              {event.contest_id ? 'Contest' : 'Tournament'}
            </Typography>
          }
          style={{ background: 'rgba(0, 0, 0, 0.25)', cursor: isClickable ? 'pointer' : 'default' }}
        />
        <Box sx={{ display: 'flex', gap: 1 }}>
          <When condition={!!categoryName}>
            <GameTypeIcon
              gameType={categoryName}
              size="small"
              color="text.tertiary"
            />
          </When>
          <Typography
            variant="h5"
            color="text.primary"
            sx={{ wordWrap: 'break-word', textTransform: 'uppercase' }}
          >
            {playersCountName} {event.title}
          </Typography>
        </Box>
      </Box>
      <Typography
        variant="subtitle2"
        color="text.secondary"
      >
        Prize pool: <b>{prize}</b>
      </Typography>
    </Paper>
  )
}

export default RoadmapEvent
